import React from "react";
import PropTypes from "prop-types";
import { useIntl } from "react-intl";
import styled from "@emotion/styled";
import ReportsConstants from "reports/utils/ReportsConstants";
import ReportsMessages from "reports/intl/ReportsMessages";

const { ACTIVE } = ReportsConstants;
const StLabel = styled.span`
  font-weight: normal;
`;

const ReportStatus = ({ reportStatus }) => {
  const { formatMessage } = useIntl();
  const statusText =
    reportStatus === ACTIVE
      ? formatMessage(ReportsMessages.active)
      : formatMessage(ReportsMessages.inactive);

  return <StLabel>{statusText}</StLabel>;
};

ReportStatus.propTypes = {
  reportStatus: PropTypes.string,
};

export default ReportStatus;
